module.exports = __webpack_public_path__ + "static/img/IMG_20151020_092921.9c123044.jpg";